module.exports = __webpack_public_path__ + "media/images/hero-mobile-c60bd5f330a7c8f26cbc56df0bb4883e.jpg";